import { render, staticRenderFns } from "./billsAndPayment.vue?vue&type=template&id=dce76fd2"
import script from "./billsAndPayment.vue?vue&type=script&lang=js"
export * from "./billsAndPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports